// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_WcJFe","dbox":"index_dbox_UfehW"};